import React from "react";
import { connect } from "react-redux";
import { callService, formatDate, goTo } from "../tools";
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import Checkbox from 'material-ui/Checkbox';
import Modal from '../generalcomponets/modal-mobile';
import HandleErrorCodes from '../generalcomponets/handleErrorCodes';
import MediosElectronicos from "../gnp-registro/mediosElectronicos.cmpt";
import ModalSintillo from '../mensajes-tooltips/mensajes-tooltips.cmpt';

const palabraErrorMayus = "Error";
const palabraErrorMin = "error";
const gnpContentTextModal = "De ahora en adelante deberás acceder a tu sesión ingresando tu correo y contraseña,"+
	"mismos que podrás utilizar en la aplicación Soy Cliente GNP. Recibirás un SMS con tu número de cliente, " +
	"el cual podrás utilizar para los servicios del call center."

const avisoPrivacidadTxt = "Grupo Nacional Provincial, S.A.B., con domicilio en Avenida Cerro de las Torres No. 395, " +
    "Colonia Campestre Churubusco, Código Postal 04200, Alcaldía Coyoacán, Ciudad de México, " +
    "tratará sus datos personales, patrimoniales e incluso sensibles para evaluar su solicitud de seguro  " +
    "y en caso de ser aceptada brindarle los servicios relacionados con su contrato de seguro. Puede " +
    "consultar la versión integral del Aviso de Privacidad en la página www.gnp.com.mx";
const avisoPrivacidadTxt2 = "Al hacer clic en “CONTINUAR” reconozco que previo al tratamiento y a proporcionar mis datos " +
    "personales se ha puesto a mi disposición el Aviso de Privacidad Integral de Grupo Nacional " +
    "Provincial, S.A.B. (en lo sucesivo GNP), el cual he leído y comprendido, por lo que tengo " +
    "conocimiento de (i) la identidad y domicilio de GNP; (ii) los datos personales que serán sujetos " +
    "a tratamiento; (iii) las finalidades primarias y secundarias del tratamiento, así como las " +
    "transferencias que van a efectuarse; (iv) los medios habilitados para limitar el uso o divulgación " +
    "de mis datos personales y/o revocar mi consentimiento, así como para ejercer mis derechos de acceso, " +
    "rectificación, cancelación y oposición. Asimismo manifiesto tener conocimiento que puedo consultar el " +
    "Aviso de Privacidad Integral y sus actualizaciones en cualquier momento en la página www.gnp.com.mx";
const avisoPrivacidadTxt3 = "En caso de haber proporcionado datos personales de otros titulares, reconozco haber cumplido con mi obligación " +
    "de informarles sobre su entrega, haber obtenido de forma previa el consentimiento de éstos para su tratamiento, " +
    "así como haberles informado los lugares en los que se encuentra disponible el Aviso de Privacidad Integral para su consulta.";

const mapState = (state) => {
	return {
		loading: state.global.loading,
		hashOne: state.registroAF.hashOne,
		hashTwo: state.registroAF.hashTwo,
		apaterno: state.registroAF.apaterno,
		amaterno: state.registroAF.amaterno,
		nombres: state.registroAF.nombres,
		email: state.registroAF.email,
		fechaNacimientoDate: state.registroAF.fechaNacimientoDate,
		genero: state.registroAF.genero,
		ladaCelular: state.registroAF.ladaCelular,
		telCelular: state.registroAF.telCelular,
		rfc: state.registroAF.rfc,
		poliza: state.registroAF.poliza,
		password: state.registroAF.password,
		pregunta1: state.registroAF.pregunta1,
		pregunta2: state.registroAF.pregunta2,
		respuesta1: state.registroAF.respuesta1,
		respuesta2: state.registroAF.respuesta2,
		mediosElectronicos: state.registroAF.mediosElectronicos,
		datosPersonales: state.registroAF.datosPersonales,
		dispositivo: state.global.dispositivo
	};
};

const mapDispatch = (dispatch) => {
	return {
		loader: (show) => {
			dispatch({ "type": "LOADER", "show": show });
		},
		alerta: (sMensaje) => {
			dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", "titulo": "ERROR", "mensaje": sMensaje });
		},
		alertaCode: (sCode) => {
			dispatch({ "type": "MODAL_ALERT_CODE_SHOW", "codigo": sCode });
		},
		siguientePaso: () => {
			dispatch({ "type": "REGISTRO_FAMILIAR_PASO", "paso": 3 });
		},
		registrarDatos(bAccept) {
			dispatch({ "type": "REGISTRO_FAMILIAR_CONTRATO_DP", "datosPersonales": bAccept });
		},
		tagManager: (oDataTagManager) => {
			dispatch(oDataTagManager);
		}
	};
};

const mensajeError = "Error al registrar el cliente.";

class Confidencialidad extends React.Component {

	state = {
		isModalOpened: false,
		modalMesage: { type: null, title: null, message: null },
		showTooltip: false,
		mensaje: "",
		type: "",
		titulo: "",
		habilitaBtnAviso: true
	}

	aceptarAvisoMedios = () => {

        localStorage.setItem("aceptarAviso", true);
        localStorage.setItem("mediosElectronicos", true);
		this.props.registrarDatos(localStorage.getItem("aceptarAviso"));

		var type = (localStorage.getItem("aceptarAviso") === "true") ? "EVENT_ACCESOFAMILIAR_SIG-CONSENTIMIENTO-ACEPTAR" : "EVENT_ACCESOFAMILIAR_SIG-CONSENTIMIENTO-RECHAZAR";
		this.props.tagManager({ "type": "EVENT_ACCESOFAMILIAR_SIG-TERMINOS-ACEPTAR", "dispositivo": this.props.dispositivo });
		this.props.tagManager({ "type": type, "dispositivo": this.props.dispositivo });
		this.props.loader(true);

		new callService({
			service: "accesoFamiliar.registroInvitacion",
			secure: true,
			data: {
				hashOne: this.props.hashOne,
				hashTwo: this.props.hashTwo,
				apaterno: this.props.apaterno,
				amaterno: this.props.amaterno,
				nombres: this.props.nombres,
				email: this.props.email,
				fechaNacimiento: formatDate(this.props.fechaNacimientoDate),
				genero: this.props.genero,
				ladaCelular: localStorage.getItem("lada_movil"),
				telCelular: localStorage.getItem("telefono_movil"),
				rfc: this.props.rfc,
				poliza: this.props.poliza,
				password: this.props.password,
				pregunta1: "PSC15",
				pregunta2: "PSC04",
				respuesta1: "negro",
				respuesta2: "nissan",
				mediosElectronicos: localStorage.getItem("mediosElectronicos"),
				datosPersonales: localStorage.getItem("aceptarAviso")
			}
		}).execute().then((respuesta) => {
			console.log("Respuesta", respuesta);
			this.props.loader(false);
			this.respuestaExitosa(respuesta);
		}).catch((error) => {
			this.props.loader(false);

			console.log("Error acceso compartido", error);

			if (error.message.codigoError) {
				if (this.props.dispositivo === 'app') {
					this.setState({
						isModalOpened: true,
						modalMesage: {
							type: palabraErrorMin,
							title: palabraErrorMayus,
							message: HandleErrorCodes(error.message.codigoError)
						}
					});
				} else {
					if (error.message.mensaje.includes(mensajeError) || error.message.mensaje === "") {
						this.muestraTooltip(true, palabraErrorMin, palabraErrorMayus, mensajeError);
					} else {
						this.muestraTooltip(true, palabraErrorMin, palabraErrorMayus, error.message.mensaje);
					}
				}
			} else {
				this.respuestaError(error);	
			}

		});
    }

	respuestaExitosa = (respuesta) => {
		if (respuesta.aceptacionInvitado.banExito) {
			if (this.props.dispositivo === 'app') {
				this.setState({ isModalOpened: true })
			} else {
				$("#modal-bienvenida").modal({ backdrop: "static", keyboard: false });
			}
		}
	}

	respuestaError = (error) => {
		if (this.props.dispositivo === 'app') {
			this.setState({
				isModalOpened: true,
				modalMesage: {
					type: palabraErrorMin,
					title: palabraErrorMayus,
					message: error.message.mensaje
				}
			});
		} else {
			if (error.message.mensaje.includes(mensajeError)) {
				this.muestraTooltip(true, palabraErrorMin, palabraErrorMayus, mensaje);
			} else {
				this.muestraTooltip(true, palabraErrorMin, palabraErrorMayus, error.message.mensaje);
			}
		}
	}

	enviarLogin = () => {
		if (this.props.dispositivo === 'app')
			this.closeModalFromChild();

		goTo("login");
	}

	openModalParent = (type, title, message) => {
		let { isModalOpened } = this.state;

		if (isModalOpened)
			this.setState({ isModalOpened: false, modalMesage: { type: null, title: null, message: null } })
		else {
			this.setState({ isModalOpened: true });
		}
	}

	closeModalFromChild = () => {
		this.setState({ isModalOpened: false, modalMesage: { type: null, title: null, message: null } });
	}

	muestraTooltip = (show, type?, titulo?, mensaje?) => {
		setTimeout(() => {
			this.setState({ showTooltip: show, type: type, titulo: titulo, mensaje: mensaje });
		}, 300);
	}

	cierraTooltip = e => {
		this.setState({
			showTooltip: !this.state.showTooltip
		});
	}

	checkAviso = () => {
        console.log("Estado del checkbox Aviso: " + aceptarAviso.checked);
        this.habilitaBotonPrivacidad();
    }

    checkAvisoTerminos = () => {
        console.log("Estado del checkbox Medios: " + mediosElectronicos.checked);
        this.habilitaBotonPrivacidad();
    }

    habilitaBotonPrivacidad = () => {
        if (aceptarAviso.checked === false || mediosElectronicos.checked === false) {
            this.setState({ "habilitaBtnAviso": true });
        } else {
            this.setState({ "habilitaBtnAviso": false });
        }
    }

	showModal = () => {
        $("#modal-terminos-condiciones").modal({ backdrop: "static", keyboard: false });
    }

	render() {
		const { handleSubmit } = this.props;
		return (
			<div>
				<ModalSintillo onClose={this.cierraTooltip} titulo={this.state.titulo}
					show={this.state.showTooltip} type={this.state.type} mensaje={this.state.mensaje}>
				</ModalSintillo>
				<form >
					<div className="avisoPrivacidad-content">
						<div>
							<div className="avisoPrivacidad-titulo">
								<p>AVISO DE PRIVACIDAD INTEGRAL</p>
								<hr />
							</div>

							<div className="avisoPrivacidad-body">
								<div className="avisoPrivacidad-type-txt">{avisoPrivacidadTxt}</div> <br />
								<div className="avisoPrivacidad-type-txt">{avisoPrivacidadTxt2}</div> <br />
								<div className="avisoPrivacidad-type-txt">{avisoPrivacidadTxt3}</div> <br />
							</div>

							<div className="avisoPrivacidad-footer">
								<div className="content-check">
									<MuiThemeProvider>
										<Checkbox
											id="aceptarAviso" name="aceptarAviso" className="check-aviso" value="aviso" 
											onChange={this.checkAviso} onClick={this.checkAviso}
											iconStyle={{ color: "#0C2040 !important", fill: "#FF6B0B" }}
										/>
									</MuiThemeProvider>
									<p className="avisoPrivacidad-type-txt">
										Conozco y entiendo que mis datos son tratados conforme al Aviso de privacidad Integral
									</p>
								</div>
								<div id="terminosCondiciones" className="margin-top-terminos">
									<MuiThemeProvider>
										<Checkbox
											id="mediosElectronicos" name="mediosElectronicos" value="mediosElectronicos" 
											onChange={this.checkAvisoTerminos} onClick={this.checkAvisoTerminos}
											iconStyle={{ color: "#0C2040 !important", fill: "#FF6B0B" }}
										/>
									</MuiThemeProvider>
									<div id="terCon" style={{ marginTop: "-24px", position: "absolute" }}>
										<span className="avisoPrivacidad-type-txt" id="terminosCondiciones-1" style={{ marginLeft: "37px" }}>
											He leído y acepto los</span>
										<span className="avisoPrivacidad-type-txt" id="terminosCondiciones-2" style={{ marginLeft: "-10px" }} onClick={this.showModal}>
											Términos y condiciones de uso de Medios Electrónicos</span>
										<span className="avisoPrivacidad-type-txt" id="terminosCondiciones-3" style={{ marginLeft: "-10px" }}>
											de Grupo Nacional Provincial S.A.B</span><br />
									</div>
								</div>

								<button type="button" disabled={this.state.habilitaBtnAviso}
									id="btnAceptarAviso" className='orange-rectangle' onClick={this.aceptarAvisoMedios}>
									Continuar
								</button>
							</div>
							<div className="modal fade modal-msj" id="modal-terminos-condiciones"
								tabIndex="-1" role="dialog" aria-labelledby="modal-terminos-condiciones"
								data-backdrop="static" data-keyboard="false">

								<div className="modal-dialog modal-terminos-responsive" role="document">
									<div className="modal-content" id="div-body-modal">
										<MediosElectronicos></MediosElectronicos>
									</div>
								</div>
							</div>
						</div>
					</div>
				</form>
				<div className="modal modal-msj fade" id="modal-bienvenida" tabIndex="-1" role="dialog" aria-labelledby="id-modal-bienvenida">
					<div className="modal-dialog" role="document">
						<div className="modal-content">
							<div className="">
								<h5 id="id-modal-title" className="text-center">¡Bienvenido!</h5>
							</div>
							<div className="txt-black">
								<p>Tu información se ha guardado satisfactoriamente.</p>
								<p>De ahora en adelante deberás acceder a tu sesión ingresando tu correo y contraseña, mismos que podrás utilizar en la aplicación Soy Cliente GNP. Recibirás un SMS con tu número de cliente, el cual podrás utilizar para los servicios del call center.</p>
							</div>
							<div className="text-center aceptar-cancelar-btn mt-20">
								<button type="button" className="btn orange-btn" onClick={this.enviarLogin} data-dismiss="modal">Aceptar</button>
							</div>
						</div>
					</div>
				</div>
				{this.state.isModalOpened &&
					<Modal closeModalFromChild={this.closeModalFromChild}>
						<div>
							<div className="row">
								<div className="col-md-12 col-sm-12 col-xs-12 text-center margin-modal-top">
									{this.state.modalMesage.type === palabraErrorMin ? 
									<img src={require('../img/warning-new-style.svg')} alt="Error image modal" 
									className="gnp-material-comtent-image" /> 
									: <img src={require('../img/verified_user_success.svg')} alt="Error image modal" 
									className="gnp-material-comtent-image" />}
								</div>
								<div className="col-md-12 col-sm-12 col-xs-12 text-center margin-modal">
									{this.state.modalMesage.type === palabraErrorMin ? 
									<label className="gnp-material-title-modal">{this.state.modalMesage.title}</label> 
									: <label className="gnp-material-title-modal">¡Bienvenido!</label>}
								</div>
								<div className="col-md-12 col-sm-12 col-xs-12 text-center margin-modal">
									{this.state.modalMesage.type === palabraErrorMin ?
										<p className=" gnp-material-content-modal">{this.state.modalMesage.message}</p>
										:
										<div>
											<p className=" gnp-material-content-modal">Tu información se ha guardado satisfactoriamente.</p>
											<p className=" gnp-material-content-modal">{gnpContentTextModal}</p>
										</div>
									}

								</div>
								<div className="col-md-12 col-sm-12 col-xs-12 text-center margin-modal-bottom">
									<button type="button" onClick={this.state.modalMesage.type === palabraErrorMin ? 
										this.closeModalFromChild : this.enviarLogin} className="pure-material-button-contained btn-full-width">
											{this.state.modalMesage.type === palabraErrorMin ? 'OK' : 'Aceptar'}</button>
								</div>
							</div>
						</div>
					</Modal>}
			</div>
		);
	}
}

export default connect(mapState, mapDispatch)(Confidencialidad);


// WEBPACK FOOTER //
// ./src/gnp-registro-familiar/contrato-datos.cmpt.js